import React, { useCallback, useEffect, useState } from "react";
import ImageUploading from "react-images-uploading";
import secureLocalStorage from "react-secure-storage";
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import {
  AvatarEditProfile,
  ButtonEdits,
  ButtonSave,
  ButtonUpload,
  ButtonUploadInfo,
  Container,
  DescriptionHead,
  DescriptionText,
  Full,
  Header,
  Heading,
  HorizontalStack,
  InputBox,
  InputWrapper,
  LabelInput,
  LabelWrapper,
  LeftInfo,
  Line,
  Main,
  MiddleInfo,
  NavLeft,
  NavRest,
  Text,
  VerticalStack,
  VStack
} from "./styles";

import iconLogo from "../../assets/LogoUx.svg";

import MultiplesAvatarLetter from "../../../master/components/MultiplesAvatarLetter";
import { useMainHook } from "../../../../hooks/main";
import DropdownAvatarDash from "../../../editor/components/DropdownAvatarDash";
import { useNavigate } from "react-router-dom";
import {
  InputRadio,
  OptionLabel,
  WrapperRadio,
  WrapperRadioII,
  RadioBox
} from "../../../register/screen/styles";

import imageTest from "../../assets/eating.jpg";
import api from "../../../../services/api";
import { userInfo } from "os";
import { LoadingFlex } from "../../../login/pages/Login/styles";
import LoadingEditor from "../../../editor/components/LoadingEditor";
import MoonLoader from "react-spinners/MoonLoader";
import { useAuth } from "../../../../hooks/auth";
import { ContractAnimation } from "../../../../shared/components/ContractAnimation";
import StyledMaskInput from "../../../register/components/StyledMaskInput";
import StyledMask from "./components/StyledMask/Index";

interface UserProps {
  user?: {
    id: string;
    people_id: string;
    email: string;
    avatar: string;
    is_admin: boolean;
    is_blocked: boolean;
    user_type: string;
    created_at: string;
    updated_at: string;
    avatar_url: string;
  };
  people?: {
    id: string;
    address_id: string;
    contact_id: string;
    first_name: string;
    last_name: string;
    born_at: null | string | any;
    gender: null | string | any;
    document: null | number | any;
    is_finished: boolean;
    created_at: string;
    updated_at: string;
    is_individual: boolean;
  };
  addresses?: {
    id: string;
    zipcode: any;
    street: any;
    number: any;
    district: any;
    city: any;
    state: any;
    country: any;
    is_finished: boolean;
    created_at: string;
    updated_at: string;
  };
  contacts?: {
    id: string;
    phone: string;
    is_finished: boolean;
    created_at: string;
    updated_at: string;
  };
  is_finished_profile?: boolean;
}

interface IWorks {
  where_do_you_work: string | null;
  how_did_you_meet_us: string | null;
}

const EditAccount: React.FC = () => {
  const { srcAvatar, refreshAvatar, setRefreshAvatar } = useMainHook();
  const [isOpenAvatarConfig, setIsOpenAvatarConfig] = useState(false);
  const navigate = useNavigate();
  const [color, setColor] = useState("");
  const [avatar, setAvatar] = useState("");
  const [work, setWork] = useState<IWorks>({
    where_do_you_work: "",
    how_did_you_meet_us: ""
  });
  const [loadImage, setLoadImage] = useState(false);
  const [userWithoutWork, setUserWhithoutWork] = useState(false);

  const handleNavigateHome = useCallback(() => {
    navigate("/");
  }, []);

  const [userInfos, setUserInfos] = useState<UserProps>({});
  const [userWork, setUserWork] = useState("");
  const [typeRegisterCustomer, setTypeRegisterCustomer] = useState<
    "cpf" | "cnpj"
  >("cpf");
  const [loading, setLoading] = useState(true);
  const [loadingButton, setLoadingButton] = useState(false);

  const [changeUser, setChangeUser] = useState<any>({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    document: "",
    is_individual: true
  });

  const handlePortalCustomer = useCallback(async () => {
    try {
      const response = await api.post("stripe/create-session-portal");
      const { url } = response.data;
      window.open(`${url}`);
    } catch (err) {
      alert(err.message);
    }
  }, []);

  const [images, setImages] = useState([]);

  const maxNumber = 69;

  const onChange = async (imageList, addUpdateIndex) => {
    // data for submit
    setImages(imageList);
    let formData = new FormData();
    formData.append("avatar", imageList[0].file);
    try {
      setLoadImage(true);
      const fetchUploadAvatarResponse = await api.patch(
        `users/avatar`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );
      setLoadImage(false);
      setRefreshAvatar(!refreshAvatar);
      setImages([]);
      toast.success("Foto de perfil atualizada com sucesso!");
    } catch (err) {
      console.log(err, "error when update avatar");
    }
  };

  const handleSubmitChanges = useCallback(async () => {
    let stepOne = false;
    let stepTwo = false;

    try {
      console.log(changeUser, "como ta indo pra api");
      setLoadingButton(true);
      const response = await api.put("profile", changeUser);
      stepOne = true;
    } catch (err) {
      console.log(
        err.response.data.message,
        "Error when update changes profile"
      );

      if (
        err.response.data.message === "Invalid CPF." ||
        err.response.data.message === "Invalid CNPJ."
      ) {
        toast.error("CPF ou CNPJ inválido!");
      } else {
        toast.error("Todos os campos são obrigatórios");
      }

      setLoadingButton(false);
    }

    //if not exist i have created work action

    if (userWithoutWork) {
      try {
        const responseCreateWork = await api.post("create-account-questions", {
          where_do_you_work: work.where_do_you_work,
          how_did_you_meet_us: "Já era cadastrado"
        });

        toast.success("Sucesso!");
        setLoading(false);
      } catch (err) {
        setLoadingButton(false);
        toast.error("ERRO, algo deu errado!");
      }
    } else {
      try {
        const responseWork = await api.put("create-account-questions", {
          where_do_you_work: work.where_do_you_work,
          how_did_you_meet_us: work.how_did_you_meet_us
            ? work.how_did_you_meet_us
            : "Já era cadastrado"
        });

        setLoadingButton(false);
        stepTwo = true;
      } catch (err) {
        console.log(err.response.data, "ERROR when update work user");
        setLoadingButton(false);
        console.log(err?.response?.data?.message, "error");
        toast.error("ERRO, algo deu errado!");
      }

      if (stepOne && stepTwo) {
        toast.success("Perfil atualizado com sucesso!");
        setModifyProfile(!modifyProfile);
      }
    }
  }, [changeUser, work, userWithoutWork]);

  useEffect(() => {
    setRefreshAvatar(!refreshAvatar);
  }, [images]);

  useEffect(() => {
    setChangeUser({
      ...changeUser,
      first_name: `${userInfos?.people?.first_name}`,
      last_name: `${userInfos?.people?.last_name}`,
      phone: userInfos?.contacts?.phone,
      email: userInfos?.user?.email,
      document: userInfos?.people?.document,
      is_individual: userInfos?.people?.is_individual
    });

    setAvatar(userInfos?.user?.avatar_url);
  }, [userInfos]);

  useEffect(() => {
    const autoLoadUser = async () => {
      try {
        const response = await api.get("profile");
        setUserInfos(response.data as UserProps);
        setLoading(false);
      } catch (err) {
        console.log(err, "error when get profile");
      }
    };

    autoLoadUser();
  }, [refreshAvatar]);

  useEffect(() => {
    const autoLoad = async () => {
      try {
        const response = await api.get("create-account-questions");
        setWork({
          where_do_you_work: response.data.where_do_you_work,
          how_did_you_meet_us: response.data.how_did_you_meet_us
        });
      } catch (err) {
        console.log(err, "caiu aqui");
        setUserWhithoutWork(true);
      }
    };

    autoLoad();
  }, []);

  const { userStripe, modifyProfile, setModifyProfile } = useAuth();

  //if dont have stripe subscription then we cant show button
  //for management stripe account and also if not show it
  const [isUserStripe, setIsUserStripe] = useState(true);
  useEffect(() => {
    (async () => {
      try {
        const requestForStripe = await api.post("stripe/create-session-portal");

        if (requestForStripe.status === 200) {
          setIsUserStripe(true);
        } else {
          setIsUserStripe(false);
        }
      } catch (err) {
        setIsUserStripe(false);
      }
    })();
  }, []);

  const [customerValueRegister, setCustomerValueRegister] = useState("");

  const handleRegisterCustomer = useCallback(
    (value, mask) => {
      setCustomerValueRegister(mask._unmaskedValue);
    },
    [customerValueRegister]
  );

  useEffect(() => {
    if (userInfos?.people?.document) {
      setCustomerValueRegister(userInfos.people.document);
    }

    if (userInfos?.people?.document?.length <= 11) {
      setTypeRegisterCustomer("cpf");
    }

    if (userInfos?.people?.document?.length > 11) {
      setTypeRegisterCustomer("cnpj");
    }
  }, [userInfos]);

  useEffect(() => {
    setChangeUser(state => {
      return {
        ...state,
        document: customerValueRegister
      };
    });
  }, [customerValueRegister]);

  useEffect(() => {
    setChangeUser(state => {
      return {
        ...state,
        is_individual: typeRegisterCustomer === "cpf" ? true : false
      };
    });
  }, [typeRegisterCustomer]);

  return (
    <Container>
      <ToastContainer />

      {loading ? (
        <LoadingFlex>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "90vh",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            {/* <LoadingEditor /> */}
            <ContractAnimation />
          </div>
        </LoadingFlex>
      ) : (
        <>
          <Header>
            <NavLeft>
              <button
                style={{ background: "transparent" }}
                onClick={() => navigate("/")}
              >
                <img src={iconLogo} className="logo-uxdoc-account" />
              </button>
              <button>
                <Text onClick={handleNavigateHome}>Início</Text>
              </button>
            </NavLeft>
            <NavRest>
              <div style={{ marginLeft: "auto" }}>
                <DropdownAvatarDash
                  isOpen={isOpenAvatarConfig}
                  setIsOpen={setIsOpenAvatarConfig}
                  color={color}
                >
                  <MultiplesAvatarLetter
                    className="avatar-dashboard"
                    src={String(srcAvatar)}
                    // text={letters}
                    // setText={setLetters}
                    // color={getColors(true)}
                  />
                </DropdownAvatarDash>
              </div>
            </NavRest>
          </Header>
          <Line />
          <Full>
            <Main>
              <Heading>Informações da conta</Heading>
              <VStack>
                <LeftInfo>
                  {!loadImage ? (
                    <div>
                      <AvatarEditProfile src={avatar} />
                    </div>
                  ) : (
                    <LoadingFlex>
                      <MoonLoader size={18} color="#000" />
                    </LoadingFlex>
                  )}
                </LeftInfo>
                <MiddleInfo>
                  <DescriptionHead>
                    Faça upload da sua foto de perfil
                  </DescriptionHead>
                  <DescriptionText>
                    Coloque sua foto para que reconheçam você quando
                    compartilhar um documento no UX DOC.
                  </DescriptionText>
                </MiddleInfo>
                <ButtonUploadInfo>
                  <ImageUploading
                    multiple
                    value={images}
                    onChange={onChange}
                    maxNumber={maxNumber}
                    dataURLKey="data_url"
                  >
                    {({
                      imageList,
                      onImageUpload,
                      onImageRemoveAll,
                      onImageUpdate,
                      onImageRemove,
                      isDragging,
                      dragProps
                    }) => (
                      // write your building UI
                      <ButtonUpload onClick={onImageUpload} {...dragProps}>
                        Fazer upload da foto
                      </ButtonUpload>
                    )}
                  </ImageUploading>
                </ButtonUploadInfo>
              </VStack>
              <InputBox>
                <LabelWrapper>
                  <LabelInput>Nome</LabelInput>
                </LabelWrapper>
                <InputWrapper
                  value={changeUser.first_name}
                  onChange={e =>
                    setChangeUser({ ...changeUser, first_name: e.target.value })
                  }
                />
              </InputBox>
              <InputBox>
                <LabelWrapper>
                  <LabelInput>Sobrenome</LabelInput>
                </LabelWrapper>
                <InputWrapper
                  value={changeUser.last_name}
                  onChange={e =>
                    setChangeUser({ ...changeUser, last_name: e.target.value })
                  }
                />
              </InputBox>
              <InputBox>
                <LabelWrapper>
                  <LabelInput>Email</LabelInput>
                </LabelWrapper>
                <InputWrapper
                  value={changeUser.email}
                  // onChange={e =>
                  //   setChangeUser({ ...changeUser, email: e.target.value })
                  // }
                  style={{ cursor: "not-allowed" }}
                  readOnly
                />
              </InputBox>
              <InputBox>
                <LabelWrapper>
                  <LabelInput>Celular</LabelInput>
                </LabelWrapper>
                <InputWrapper
                  value={changeUser.phone}
                  onChange={e =>
                    setChangeUser({ ...changeUser, phone: e.target.value })
                  }
                />
              </InputBox>

              <InputBox>
                <LabelWrapper>
                  <div>
                    <select
                      onChange={(
                        event: React.ChangeEvent<HTMLSelectElement>
                      ) => {
                        if (event.target?.value === "cpf") {
                          setTypeRegisterCustomer("cpf");
                        } else if (event.target?.value === "cnpj") {
                          setTypeRegisterCustomer("cnpj");
                        }
                      }}
                    >
                      <option
                        selected={typeRegisterCustomer === "cpf" ? true : false}
                        value={"cpf"}
                      >
                        CPF
                      </option>
                      <option
                        selected={
                          typeRegisterCustomer === "cnpj" ? true : false
                        }
                        value={"cnpj"}
                      >
                        CNPJ
                      </option>
                    </select>
                  </div>
                </LabelWrapper>
                <StyledMask
                  mask={
                    typeRegisterCustomer === "cpf"
                      ? "000.000.000-00"
                      : "00.000.000/0000-00"
                  }
                  value={customerValueRegister}
                  onAccept={(value, mask) =>
                    handleRegisterCustomer(value, mask)
                  }
                />
              </InputBox>

              <Text>Onde você atua?</Text>

              <HorizontalStack>
                <input
                  type="radio"
                  value="Escritório de advocacia pequeno"
                  onChange={e =>
                    setWork({
                      where_do_you_work: e.target.value,
                      how_did_you_meet_us: work.how_did_you_meet_us
                    })
                  }
                  className="purple-radio"
                  name="radAnswer"
                  checked={
                    work.where_do_you_work === "Escritório de advocacia pequeno"
                  }
                />
                <span>Escritório de advocacia pequeno</span>
              </HorizontalStack>

              <HorizontalStack>
                <input
                  type="radio"
                  value="Escritório de advocacia grande"
                  onChange={e =>
                    setWork({
                      where_do_you_work: e.target.value,
                      how_did_you_meet_us: work.how_did_you_meet_us
                    })
                  }
                  className="purple-radio"
                  name="radAnswer"
                  checked={
                    work.where_do_you_work === "Escritório de advocacia grande"
                  }
                />
                <span>Escritório de advocacia grande</span>
              </HorizontalStack>

              <HorizontalStack>
                <input
                  type="radio"
                  value="Departamento jurídico de empresa"
                  onChange={e =>
                    setWork({
                      where_do_you_work: e.target.value,
                      how_did_you_meet_us: work.how_did_you_meet_us
                    })
                  }
                  className="purple-radio"
                  name="radAnswer"
                  checked={
                    work.where_do_you_work ===
                    "Departamento jurídico de empresa"
                  }
                />
                <span>Departamento jurídico de empresa</span>
              </HorizontalStack>

              <HorizontalStack>
                <input
                  type="radio"
                  value="Sou autônomo (a)"
                  onChange={e =>
                    setWork({
                      where_do_you_work: e.target.value,
                      how_did_you_meet_us: work.how_did_you_meet_us
                    })
                  }
                  className="purple-radio"
                  name="radAnswer"
                  checked={work.where_do_you_work === "Sou autônomo (a)"}
                />
                <span>Sou autônomo (a)</span>
              </HorizontalStack>

              <HorizontalStack>
                <input
                  type="radio"
                  value="Sou estudante de Direito"
                  onChange={e =>
                    setWork({
                      where_do_you_work: e.target.value,
                      how_did_you_meet_us: work.how_did_you_meet_us
                    })
                  }
                  className="purple-radio"
                  name="radAnswer"
                  checked={
                    work.where_do_you_work === "Sou estudante de Direito"
                  }
                />
                <span>Sou estudante de Direito</span>
              </HorizontalStack>

              <HorizontalStack>
                <input
                  type="radio"
                  value="Não tenho formação na área jurídica"
                  onChange={e =>
                    setWork({
                      where_do_you_work: e.target.value,
                      how_did_you_meet_us: work.how_did_you_meet_us
                    })
                  }
                  className="purple-radio"
                  checked={
                    work.where_do_you_work ===
                    "Não tenho formação na área jurídica"
                  }
                  name="radAnswer"
                />
                <span>Não tenho formação na área jurídica</span>
              </HorizontalStack>

              <ButtonSave onClick={handleSubmitChanges}>
                {loadingButton ? (
                  <LoadingFlex>
                    <LoadingEditor color="#fff" width={20} height={20} />
                  </LoadingFlex>
                ) : (
                  `Salvar alterações`
                )}
              </ButtonSave>

              <Line margin="4rem 0 2rem 0" />
            </Main>

            <VerticalStack>
              {isUserStripe && (
                <ButtonEdits margin="0rem 0" onClick={handlePortalCustomer}>
                  Gerenciar assinatura
                </ButtonEdits>
              )}

              <ButtonEdits
                margin="1rem 0 0 0"
                onClick={() => navigate("/perfil/nova-senha")}
              >
                Alterar senha
              </ButtonEdits>
              <ButtonEdits
                onClick={() =>
                  window.open("https://bitsacademy.typeform.com/to/IWl1i1ly")
                }
                color="#A5A5A5"
                margin="1rem 0 0 0"
              >
                Remover os dados da conta
              </ButtonEdits>
            </VerticalStack>
          </Full>
        </>
      )}
    </Container>
  );
};

export default EditAccount;
